@use '../styles/tokens' as *;

.trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  text-align: left;
  @include text-13;
  color: $black;
}

.chevron {
  flex: none;
  width: 16px;
  height: 16px;
  color: $base-4;
}

.panel {
  margin-top: 10px;
  @include text-13;
  color: $base-4;

  ul {
    margin: 0 0 10px;
    padding-left: 18px;
  }

  li {
    margin-bottom: 6px;
  }

  a {
    color: $utility-blue;
    text-decoration: none;
  }
}
